import { useState, useEffect, useMemo, useCallback } from 'react';
import { useAuthGuard } from '@/hooks/useAuth';
import AdminLayout from '@/components/feature/AdminLayout';
import { supabase } from '@/lib/supabaseClient';

// ── Survey templates ──────────────────────────────────────────────
const ANKET_SABLONLARI: Record<string, string> = {
  tr: `VIP Antalya Transfer — Müşteri Memnuniyet Anketi 🚐✨

Sayın {musteri},

Transfer deneyiminizi değerlendirerek hizmet kalitemizi artırmamıza yardımcı olur musunuz? Kısa bir ankettir, 1 dakikanızı alır. Her bir madde için 5 üzerinden puanlamanızı belirtirseniz çok seviniriz.

1️⃣ Transferin zamanında gelmesi: ⭐⭐⭐⭐⭐
2️⃣ Araç temizliği ve konforu: ⭐⭐⭐⭐⭐
3️⃣ Şoförün ilgisi ve profesyonelliği: ⭐⭐⭐⭐⭐
4️⃣ Genel memnuniyetiniz: ⭐⭐⭐⭐⭐

Değerli müşterimiz, hizmetimizden memnun kaldıysanız ve çevrenizde transfere ihtiyaç duyan bir yakınınız ya da arkadaşınız varsa, memnuniyetinizi onlarla paylaşmamız için isim ve telefon numarasını bizimle paylaşabilirsiniz. Bu küçük jestinize teşekkür olarak bir sonraki transferinizde geçerli özel bir indirim kodu tanımlayacağız! 🎁

Yorum ve önerilerinizi bekliyoruz. Keyifli yolculuklar dileriz!

🏆 VIP Antalya Transfer
📞 +90 537 357 1894`,

  en: `VIP Antalya Transfer — Customer Satisfaction Survey 🚐✨

Dear {musteri},

Could you help us improve our service by rating your transfer experience? This is a short survey — takes just 1 minute. Please rate each item on a scale of 1 to 5 — we would greatly appreciate it!

1️⃣ Punctuality of transfer: ⭐⭐⭐⭐⭐
2️⃣ Vehicle cleanliness & comfort: ⭐⭐⭐⭐⭐
3️⃣ Driver attitude & professionalism: ⭐⭐⭐⭐⭐
4️⃣ Overall satisfaction: ⭐⭐⭐⭐⭐

As a valued guest, if you were happy with our service and know a friend or family member who might need a transfer, we would be delighted if you could share their name and phone number so we can extend the same care to them. As a thank-you for your kind referral, we will create a special discount code for your next transfer! 🎁

Your feedback means a lot to us. Wishing you pleasant journeys!

🏆 VIP Antalya Transfer
📞 +90 537 357 1894`,

  ru: `VIP Antalya Transfer — Опрос удовлетворённости клиентов 🚐✨

Уважаемый(ая) {musteri},

Помогите нам улучшить качество обслуживания, оценив ваш трансфер. Это короткий опрос — займет всего 1 минуту. Пожалуйста, оцените каждый пункт по шкале от 1 до 5 — будем очень признательны!

1️⃣ Пунктуальность трансфера: ⭐⭐⭐⭐⭐
2️⃣ Чистота и комфорт автомобиля: ⭐⭐⭐⭐⭐
3️⃣ Внимание и профессионализм водителя: ⭐⭐⭐⭐⭐
4️⃣ Общая удовлетворённость: ⭐⭐⭐⭐⭐

Уважаемый гость, если вы остались довольны нашим сервисом и у вас есть близкий человек или друг, которому может понадобиться трансфер, мы будем рады, если вы поделитесь его именем и номером телефона — мы позаботимся о нём с таким же вниманием. В благодарность за вашу рекомендацию мы подготовим для вас персональный промокод на скидку для следующей поездки! 🎁

Ваше мнение очень важно для нас. Приятных поездок!

🏆 VIP Antalya Transfer
📞 +90 537 357 1894`,

  de: `VIP Antalya Transfer — Kundenzufriedenheitsumfrage 🚐✨

Sehr geehrte(r) {musteri},

Helfen Sie uns, unseren Service zu verbessern — bewerten Sie bitte Ihr Transfer-Erlebnis. Kurze Umfrage, dauert nur 1 Minute. Bitte bewerten Sie jeden Punkt auf einer Skala von 1 bis 5 — wir würden uns sehr freuen!

1️⃣ Pünktlichkeit des Transfers: ⭐⭐⭐⭐⭐
2️⃣ Sauberkeit & Komfort des Fahrzeugs: ⭐⭐⭐⭐⭐
3️⃣ Freundlichkeit & Professionalität des Fahrers: ⭐⭐⭐⭐⭐
4️⃣ Gesamtzufriedenheit: ⭐⭐⭐⭐⭐

Lieber Gast, wenn Sie mit unserem Service zufrieden waren und jemanden aus Ihrem Freundes- oder Familienkreis kennen, der einen Transfer benötigt, würden wir uns freuen, wenn Sie uns den Namen und die Telefonnummer mitteilen — wir kümmern uns mit der gleichen Sorgfalt um ihn. Als Dankeschön für Ihre Weiterempfehlung erhalten Sie einen persönlichen Rabattcode für Ihre nächste Fahrt! 🎁

Ihr Feedback ist uns sehr wichtig. Gute Fahrt!

🏆 VIP Antalya Transfer
📞 +90 537 357 1894`,
};

const DIL_SECENEKLERI = [
  { kod: 'tr', label: '🇹🇷 Türkçe', aciklama: 'Türkçe anket gönder' },
  { kod: 'en', label: '🇬🇧 English', aciklama: 'Send survey in English' },
  { kod: 'ru', label: '🇷🇺 Русский', aciklama: 'Отправить опрос на русском' },
  { kod: 'de', label: '🇩🇪 Deutsch', aciklama: 'Umfrage auf Deutsch senden' },
];

// ── Types ─────────────────────────────────────────────────────────
interface CustomerRecord {
  id: number;
  ad_soyad: string;
  telefon: string;
  email: string;
  son_rezervasyon?: string;
}

const TEMIZLE_TELEFON = (tel: string): string => {
  if (!tel) return '';
  // Sadece rakamları ve + başlangıcını bırak
  let cleaned = tel.replace(/[\s\-()]/g, '');
  if (!cleaned.startsWith('+')) {
    if (cleaned.startsWith('0')) cleaned = '90' + cleaned.substring(1);
    cleaned = '+' + cleaned;
  }
  return cleaned;
};

const WHATSAPP_URL = (tel: string, mesaj: string): string => {
  const num = tel.replace(/^\+/, '');
  return `https://wa.me/${num}?text=${encodeURIComponent(mesaj)}`;
};

// ── Component ─────────────────────────────────────────────────────
export default function MemnuniyetAnketiPage() {
  useAuthGuard();

  const [adim, setAdim] = useState<1 | 2 | 3>(1);
  const [customers, setCustomers] = useState<CustomerRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [arama, setArama] = useState('');
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [dilKod, setDilKod] = useState('tr');
  const [gonderilen, setGonderilen] = useState<Set<number>>(new Set());
  const [mesajOnizlemeAcik, setMesajOnizlemeAcik] = useState(false);

  // ── Fetch customers with completed transfers ───────────────────
  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    setError('');

    // Doğrudan reservations tablosundan tamamlanmış transferi olan müşterileri çek
    const { data: rezData, error: rezErr } = await supabase
      .from('reservations')
      .select('id,musteri_adi,telefon,email,gelis_tarihi,durum,donus_durum,transfer_tipi')
      .or('durum.eq.Transfer Tamamlandı,donus_durum.eq.Transfer Tamamlandı')
      .order('gelis_tarihi', { ascending: false });

    if (rezErr) {
      setError(rezErr.message);
      setLoading(false);
      return;
    }

    // Benzersiz müşterileri grupla — aynı isimdeki müşterileri birleştir,
    // en son transfer tarihini ve telefon/email bilgisini sakla
    const musteriMap = new Map<string, CustomerRecord>();

    for (const r of rezData || []) {
      const ad = (r.musteri_adi || '').trim();
      if (!ad) continue;

      const key = ad.toLowerCase();

      if (!musteriMap.has(key)) {
        musteriMap.set(key, {
          id: r.id, // rezervasyon id'sini kullan
          ad_soyad: ad,
          telefon: r.telefon || '',
          email: r.email || '',
          son_rezervasyon: r.gelis_tarihi || '',
        });
      } else {
        // Aynı müşteri varsa, daha güncel tarihi ve varsa telefon/email bilgisini al
        const existing = musteriMap.get(key)!;
        if (r.gelis_tarihi && r.gelis_tarihi > (existing.son_rezervasyon || '')) {
          existing.son_rezervasyon = r.gelis_tarihi;
        }
        if (r.telefon && !existing.telefon) existing.telefon = r.telefon;
        if (r.email && !existing.email) existing.email = r.email;
      }
    }

    const enriched = Array.from(musteriMap.values());
    setCustomers(enriched);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  // ── Filter ─────────────────────────────────────────────────────
  const filtered = useMemo(() => {
    if (!arama) return customers;
    const q = arama.toLowerCase();
    return customers.filter(
      (c) =>
        c.ad_soyad?.toLowerCase().includes(q) ||
        c.telefon?.includes(q) ||
        c.email?.toLowerCase().includes(q)
    );
  }, [customers, arama]);

  const selectedCustomers = useMemo(
    () => customers.filter((c) => selectedIds.has(c.id)),
    [customers, selectedIds]
  );

  // ── Selection helpers ──────────────────────────────────────────
  const toggleSelect = (id: number) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const selectAll = () => {
    setSelectedIds(new Set(filtered.map((c) => c.id)));
  };

  const clearAll = () => {
    setSelectedIds(new Set());
  };

  // ── Navigation ─────────────────────────────────────────────────
  const goToStep2 = () => {
    if (selectedIds.size === 0) return;
    setAdim(2);
  };

  const goToStep3 = () => {
    setAdim(3);
    setMesajOnizlemeAcik(true);
  };

  const goBack = () => {
    if (adim === 2) setAdim(1);
    if (adim === 3) setAdim(2);
  };

  const resetAll = () => {
    setAdim(1);
    setSelectedIds(new Set());
    setDilKod('tr');
    setGonderilen(new Set());
    setMesajOnizlemeAcik(false);
  };

  // ── WhatsApp gönderme ──────────────────────────────────────────
  const openWhatsApp = (musteri: CustomerRecord) => {
    const sablon = ANKET_SABLONLARI[dilKod];
    const mesaj = sablon.replace('{musteri}', musteri.ad_soyad);
    const tel = TEMIZLE_TELEFON(musteri.telefon);
    if (!tel) return;
    const url = WHATSAPP_URL(tel, mesaj);
    window.open(url, '_blank', 'noopener,noreferrer');
    setGonderilen((prev) => new Set(prev).add(musteri.id));
  };

  // ── Mesaj önizleme ─────────────────────────────────────────────
  const onizlemeMesaji = useMemo(() => {
    const sablon = ANKET_SABLONLARI[dilKod];
    const ilkMusteri = selectedCustomers[0];
    return sablon.replace('{musteri}', ilkMusteri?.ad_soyad || 'Müşteri Adı');
  }, [dilKod, selectedCustomers]);

  const dilAdi = DIL_SECENEKLERI.find((d) => d.kod === dilKod)?.label || 'Türkçe';

  // ── Render ─────────────────────────────────────────────────────
  return (
    <AdminLayout>
      {/* ── Header ─────────────────────────────────────────────── */}
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h2 className="text-xl md:text-2xl font-display font-bold text-white">
            Memnuniyet Anketi
          </h2>
          <p className="text-sm text-gray-400 mt-1">
            Tamamlanan transfer müşterilerine WhatsApp üzerinden memnuniyet anketi gönderin
          </p>
        </div>
        {adim > 1 && (
          <button
            onClick={resetAll}
            className="px-4 py-2 bg-vip-dark border border-vip-gold/15 text-gray-400 text-sm rounded-md hover:text-white hover:border-vip-gold/30 transition-colors whitespace-nowrap"
          >
            <i className="ri-refresh-line mr-1"></i>Baştan Başla
          </button>
        )}
      </div>

      {/* ── Error ──────────────────────────────────────────────── */}
      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-3 mb-4 flex items-center gap-2">
          <i className="ri-error-warning-line text-red-400"></i>
          <p className="text-sm text-red-400">{error}</p>
          <button onClick={fetchCustomers} className="ml-auto text-xs text-red-400 underline">
            Tekrar dene
          </button>
        </div>
      )}

      {/* ── Adım Göstergesi ────────────────────────────────────── */}
      <div className="flex items-center gap-2 mb-6">
        {[1, 2, 3].map((a) => (
          <div key={a} className="flex items-center gap-2">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold border transition-all ${
                adim === a
                  ? 'bg-vip-gold text-vip-black border-vip-gold'
                  : adim > a
                  ? 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30'
                  : 'bg-vip-dark text-gray-500 border-vip-gold/10'
              }`}
            >
              {adim > a ? <i className="ri-check-line"></i> : a}
            </div>
            <span
              className={`text-xs whitespace-nowrap ${
                adim >= a ? 'text-white' : 'text-gray-500'
              }`}
            >
              {a === 1 ? 'Müşteri Seçimi' : a === 2 ? 'Dil Seçimi' : 'Gönderim'}
            </span>
            {a < 3 && (
              <div
                className={`w-8 h-px ${adim > a ? 'bg-emerald-500/40' : 'bg-vip-gold/10'}`}
              />
            )}
          </div>
        ))}
      </div>

      {/* ═══════════════════════════════════════════════════════════ */}
      {/* ADIM 1 — Müşteri Seçimi                                    */}
      {/* ═══════════════════════════════════════════════════════════ */}
      {adim === 1 && (
        <>
          {/* Arama + seçim kontrolleri */}
          <div className="flex flex-col sm:flex-row gap-3 mb-4">
            <div className="relative flex-1">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-gray-500 text-sm"></i>
              </div>
              <input
                type="text"
                placeholder="Müşteri adı veya telefon ara..."
                value={arama}
                onChange={(e) => setArama(e.target.value)}
                className="w-full bg-vip-dark border border-vip-gold/15 rounded-md pl-9 pr-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/40 transition-colors"
              />
            </div>
            <div className="flex gap-2">
              <button
                onClick={selectAll}
                className="px-3 py-2 bg-vip-dark border border-vip-gold/10 text-xs text-gray-400 rounded-md hover:text-white hover:border-vip-gold/20 transition-colors whitespace-nowrap"
              >
                Tümünü Seç
              </button>
              <button
                onClick={clearAll}
                className="px-3 py-2 bg-vip-dark border border-vip-gold/10 text-xs text-gray-400 rounded-md hover:text-white hover:border-vip-gold/20 transition-colors whitespace-nowrap"
              >
                Seçimi Temizle
              </button>
            </div>
            <div className="bg-vip-dark border border-vip-gold/10 rounded-md px-3 py-2 text-sm text-gray-400 flex items-center gap-2">
              <span className="text-vip-gold font-semibold">{selectedIds.size}</span> seçili
            </div>
          </div>

          {/* Tablo — Desktop */}
          {loading ? (
            <div className="space-y-2">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="h-12 bg-vip-dark rounded-lg animate-pulse"
                ></div>
              ))}
            </div>
          ) : (
            <>
              <div className="hidden md:block bg-vip-dark border border-vip-gold/10 rounded-lg overflow-hidden">
                <div className="overflow-x-auto max-h-[480px] overflow-y-auto">
                  <table className="w-full text-sm">
                    <thead className="sticky top-0 bg-vip-black/80 backdrop-blur-sm z-10">
                      <tr className="border-b border-vip-gold/10">
                        <th className="text-left py-3 px-4 text-gray-400 font-medium w-12">
                          <input
                            type="checkbox"
                            checked={filtered.length > 0 && selectedIds.size === filtered.length}
                            onChange={() =>
                              selectedIds.size === filtered.length
                                ? clearAll()
                                : selectAll()
                            }
                            className="w-4 h-4 rounded border-vip-gold/30 bg-vip-dark accent-vip-gold cursor-pointer"
                          />
                        </th>
                        <th className="text-left py-3 px-4 text-gray-400 font-medium">
                          Müşteri
                        </th>
                        <th className="text-left py-3 px-4 text-gray-400 font-medium">
                          Telefon
                        </th>
                        <th className="text-left py-3 px-4 text-gray-400 font-medium">
                          E-posta
                        </th>
                        <th className="text-left py-3 px-4 text-gray-400 font-medium">
                          Son Transfer
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtered.map((c) => (
                        <tr
                          key={c.id}
                          className={`border-b border-vip-gold/5 transition-colors cursor-pointer ${
                            selectedIds.has(c.id)
                              ? 'bg-vip-gold/5 hover:bg-vip-gold/8'
                              : 'hover:bg-white/5'
                          }`}
                          onClick={() => toggleSelect(c.id)}
                        >
                          <td className="py-3 px-4">
                            <input
                              type="checkbox"
                              checked={selectedIds.has(c.id)}
                              onChange={() => toggleSelect(c.id)}
                              className="w-4 h-4 rounded border-vip-gold/30 bg-vip-dark accent-vip-gold cursor-pointer"
                            />
                          </td>
                          <td className="py-3 px-4">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 rounded-full bg-vip-gold/10 flex items-center justify-center flex-shrink-0">
                                <i className="ri-user-line text-vip-gold text-xs"></i>
                              </div>
                              <span className="text-white font-medium">{c.ad_soyad}</span>
                            </div>
                          </td>
                          <td className="py-3 px-4 text-gray-300 text-xs">{c.telefon || '-'}</td>
                          <td className="py-3 px-4 text-gray-500 text-xs">{c.email || '-'}</td>
                          <td className="py-3 px-4 text-gray-400 text-xs">{c.son_rezervasyon || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Kartlar — Mobile */}
              <div className="md:hidden grid grid-cols-1 gap-3 max-h-[500px] overflow-y-auto">
                {filtered.map((c) => (
                  <div
                    key={c.id}
                    onClick={() => toggleSelect(c.id)}
                    className={`bg-vip-dark border rounded-lg p-4 cursor-pointer transition-colors ${
                      selectedIds.has(c.id)
                        ? 'border-vip-gold/30 bg-vip-gold/5'
                        : 'border-vip-gold/10 hover:bg-white/5'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-vip-gold/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-user-line text-vip-gold"></i>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-white">{c.ad_soyad}</p>
                          <p className="text-xs text-gray-500">{c.telefon || 'Telefon yok'}</p>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        checked={selectedIds.has(c.id)}
                        onChange={() => toggleSelect(c.id)}
                        className="w-5 h-5 rounded border-vip-gold/30 bg-vip-dark accent-vip-gold cursor-pointer"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Empty state */}
          {!loading && filtered.length === 0 && (
            <div className="bg-vip-dark border border-vip-gold/10 rounded-lg p-10 text-center">
              <div className="w-16 h-16 rounded-full bg-vip-gold/10 flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-search-line text-vip-gold text-2xl"></i>
              </div>
              <p className="text-sm text-gray-400 mb-1">
                {customers.length === 0
                  ? 'Henüz tamamlanmış transferi olan müşteri yok.'
                  : 'Aramaya uygun müşteri bulunamadı.'}
              </p>
              <p className="text-xs text-gray-500">
                En az bir transferi tamamlanmış müşteriler burada listelenir.
              </p>
            </div>
          )}

          {/* Devam butonu */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={goToStep2}
              disabled={selectedIds.size === 0}
              className="px-6 py-2.5 bg-vip-gold text-vip-black text-sm font-semibold rounded-md hover:bg-vip-gold-light transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap flex items-center gap-2"
            >
              <span>Devam</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </>
      )}

      {/* ═══════════════════════════════════════════════════════════ */}
      {/* ADIM 2 — Dil Seçimi                                        */}
      {/* ═══════════════════════════════════════════════════════════ */}
      {adim === 2 && (
        <>
          {/* Özet bar */}
          <div className="bg-vip-dark border border-vip-gold/10 rounded-lg p-4 mb-6 flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-vip-gold/10 flex items-center justify-center">
                <i className="ri-group-line text-vip-gold text-sm"></i>
              </div>
              <span className="text-sm text-white">
                <strong className="text-vip-gold">{selectedCustomers.length}</strong> müşteri
                seçildi
              </span>
            </div>
            <div className="hidden sm:block text-gray-500">·</div>
            <div className="flex flex-wrap gap-1.5">
              {selectedCustomers.slice(0, 5).map((c) => (
                <span
                  key={c.id}
                  className="text-xs px-2 py-0.5 bg-vip-gold/10 text-vip-gold rounded border border-vip-gold/15 whitespace-nowrap"
                >
                  {c.ad_soyad}
                </span>
              ))}
              {selectedCustomers.length > 5 && (
                <span className="text-xs text-gray-500">
                  +{selectedCustomers.length - 5} daha
                </span>
              )}
            </div>
          </div>

          {/* Dil seçenekleri */}
          <h3 className="text-base font-semibold text-white mb-4">
            Anket hangi dilde gönderilsin?
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
            {DIL_SECENEKLERI.map((d) => (
              <button
                key={d.kod}
                onClick={() => setDilKod(d.kod)}
                className={`p-4 rounded-lg border text-left transition-all ${
                  dilKod === d.kod
                    ? 'bg-vip-gold/10 border-vip-gold/30 ring-1 ring-vip-gold/20'
                    : 'bg-vip-dark border-vip-gold/10 hover:border-vip-gold/20 hover:bg-white/5'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-lg">{d.label.split(' ')[0]}</span>
                  <div>
                    <p className="text-sm font-medium text-white">{d.label}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{d.aciklama}</p>
                  </div>
                  {dilKod === d.kod && (
                    <i className="ri-checkbox-circle-fill text-vip-gold text-lg ml-auto"></i>
                  )}
                </div>
              </button>
            ))}
          </div>

          {/* Mesaj önizleme */}
          <div className="bg-vip-dark border border-vip-gold/10 rounded-lg p-5 mb-6">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-emerald-400"></i>
                </div>
                <h4 className="text-sm font-medium text-white">Mesaj Önizlemesi</h4>
              </div>
              <span className="text-xs text-gray-500">{dilAdi}</span>
            </div>
            <div className="bg-vip-black/70 border border-vip-gold/5 rounded-lg p-4 max-h-[300px] overflow-y-auto">
              <pre className="text-sm text-gray-300 whitespace-pre-wrap font-sans leading-relaxed">
                {onizlemeMesaji}
              </pre>
            </div>
            <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
              <i className="ri-information-line"></i>
              {'{musteri}'} kısmı her müşterinin adıyla otomatik değiştirilir.
            </p>
          </div>

          {/* Navigasyon */}
          <div className="flex justify-between">
            <button
              onClick={goBack}
              className="px-5 py-2.5 bg-vip-dark border border-vip-gold/10 text-gray-400 text-sm rounded-md hover:text-white hover:border-vip-gold/20 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Geri</span>
            </button>
            <button
              onClick={goToStep3}
              className="px-6 py-2.5 bg-vip-gold text-vip-black text-sm font-semibold rounded-md hover:bg-vip-gold-light transition-colors whitespace-nowrap flex items-center gap-2"
            >
              <span>Gönderime Geç</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </>
      )}

      {/* ═══════════════════════════════════════════════════════════ */}
      {/* ADIM 3 — WhatsApp Gönderimi                                 */}
      {/* ═══════════════════════════════════════════════════════════ */}
      {adim === 3 && (
        <>
          {/* Bilgi bar */}
          <div className="bg-vip-dark border border-vip-gold/10 rounded-lg p-4 mb-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center">
                <i className="ri-whatsapp-line text-emerald-400 text-lg"></i>
              </div>
              <div>
                <p className="text-sm text-white font-medium">
                  WhatsApp Web üzerinden gönderim
                </p>
                <p className="text-xs text-gray-400">
                  Her müşteriye tıklayın — WhatsApp Web otomatik açılıp mesaj hazır
                  gelecek. Sizin <strong className="text-vip-gold">Gönder</strong>{' '}
                  tuşuna basmanız yeterli.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs">
              <span className="text-gray-400">
                Gönderilen:{' '}
                <strong className="text-emerald-400">{gonderilen.size}</strong> /{' '}
                {selectedCustomers.length}
              </span>
              <span className="text-gray-500">·</span>
              <span className="text-gray-400">{dilAdi}</span>
            </div>
          </div>

          {/* Mesaj önizleme toggle */}
          <div className="mb-4">
            <button
              onClick={() => setMesajOnizlemeAcik(!mesajOnizlemeAcik)}
              className="flex items-center gap-2 text-xs text-gray-400 hover:text-white transition-colors"
            >
              {mesajOnizlemeAcik ? (
                <i className="ri-arrow-up-s-line"></i>
              ) : (
                <i className="ri-arrow-down-s-line"></i>
              )}
              {mesajOnizlemeAcik ? 'Mesajı gizle' : 'Mesajı göster'}
            </button>
            {mesajOnizlemeAcik && (
              <div className="mt-3 bg-vip-dark border border-vip-gold/10 rounded-lg p-4">
                <pre className="text-sm text-gray-300 whitespace-pre-wrap font-sans leading-relaxed max-h-[200px] overflow-y-auto">
                  {onizlemeMesaji}
                </pre>
              </div>
            )}
          </div>

          {/* Müşteri listesi — gönderim kartları */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
            {selectedCustomers.map((c, idx) => {
              const sent = gonderilen.has(c.id);
              const tel = TEMIZLE_TELEFON(c.telefon);
              const numaraGecerli = tel && tel.length >= 10;
              return (
                <div
                  key={c.id}
                  className={`bg-vip-dark border rounded-lg p-4 transition-all ${
                    sent
                      ? 'border-emerald-500/20 bg-emerald-500/5'
                      : 'border-vip-gold/10 hover:border-vip-gold/20'
                  }`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-vip-gold/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-line text-vip-gold"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-white truncate">
                        {c.ad_soyad}
                      </p>
                      <p className="text-xs text-gray-500 truncate">
                        {c.telefon || 'Telefon yok'}
                      </p>
                    </div>
                    <span className="text-[10px] text-gray-500">{idx + 1}</span>
                  </div>

                  {!numaraGecerli ? (
                    <div className="flex items-center gap-2 text-xs text-red-400 bg-red-500/10 rounded-md px-3 py-2">
                      <i className="ri-error-warning-line"></i>
                      <span>Geçersiz telefon numarası</span>
                    </div>
                  ) : sent ? (
                    <div className="flex items-center gap-2 text-xs text-emerald-400 bg-emerald-500/10 rounded-md px-3 py-2">
                      <i className="ri-check-double-line"></i>
                      <span>Gönderildi</span>
                    </div>
                  ) : (
                    <button
                      onClick={() => openWhatsApp(c)}
                      className="w-full flex items-center justify-center gap-2 px-3 py-2.5 bg-emerald-500/15 text-emerald-400 text-sm font-medium rounded-md border border-emerald-500/20 hover:bg-emerald-500/25 hover:text-emerald-300 transition-all whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-line"></i>
                      <span>WhatsApp'ta Aç</span>
                    </button>
                  )}
                </div>
              );
            })}
          </div>

          {/* Alt navigasyon */}
          <div className="flex justify-between">
            <button
              onClick={goBack}
              className="px-5 py-2.5 bg-vip-dark border border-vip-gold/10 text-gray-400 text-sm rounded-md hover:text-white hover:border-vip-gold/20 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Dil Seçimine Dön</span>
            </button>
            {gonderilen.size === selectedCustomers.length &&
              selectedCustomers.length > 0 && (
                <button
                  onClick={resetAll}
                  className="px-6 py-2.5 bg-emerald-500/20 text-emerald-400 text-sm font-semibold rounded-md border border-emerald-500/30 hover:bg-emerald-500/30 transition-colors whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-check-double-line"></i>
                  <span>Tümü Tamam — Yeni Gönderim Yap</span>
                </button>
              )}
          </div>
        </>
      )}
    </AdminLayout>
  );
}